export class SearchFacetRangeFilterProperties {
  constructor(
    public field: string,
    public label: string,
    public fromValue: string,
    public toValue: string,
    public query: string,
    public value: string
  ) {}
}
